(() => {
  const initHero = (scope = document) => {
    const hero = scope.querySelector('[data-npp-hero]') || document.querySelector('[data-npp-hero]');
    if (!hero || hero.dataset.nppReady === 'true') return;
    hero.dataset.nppReady = 'true';

    const mainImage = hero.querySelector('[data-main-product-image]');
    const quantity = hero.querySelector('[data-quantity]');
    const variantsNode = hero.querySelector('[data-npp-variants]');
    let variants = [];
    try {
      variants = JSON.parse(variantsNode?.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    const groups = Array.from(hero.querySelectorAll('[data-npp-option-group]'));
    const selectedOptions = groups.map((group) => {
      const selected = group.querySelector('[data-npp-option-value][aria-pressed="true"]');
      return selected?.dataset.nppOptionValue || '';
    });

    const updateGlobalForms = (variant) => {
      document.querySelectorAll('[data-npp-variant-id]').forEach((input) => {
        input.value = variant.id;
      });
      document.querySelectorAll('[data-npp-price]').forEach((price) => {
        price.textContent = variant.priceFormatted;
      });
      document.querySelectorAll('[data-npp-submit]').forEach((button) => {
        button.disabled = !variant.available;
        const baseLabel = variant.available ? button.dataset.availableLabel : button.dataset.soldOutLabel;
        button.textContent = button.closest('.sticky-buy') ? baseLabel : `${baseLabel}${variant.available ? ` · ${variant.priceFormatted}` : ''}`;
      });
    };

    const updateVariant = () => {
      const variant = variants.find((candidate) => (
        candidate.options.length === selectedOptions.length
        && candidate.options.every((value, index) => value === selectedOptions[index])
      ));
      if (!variant) return;

      hero.querySelector('[data-npp-variant-title]').textContent = variant.title;
      hero.querySelector('[data-npp-sku]').textContent = variant.sku || '';
      updateGlobalForms(variant);

      if (variant.image && mainImage) {
        mainImage.src = variant.image;
        mainImage.alt = variant.alt || variant.title;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    groups.forEach((group, index) => {
      group.querySelectorAll('[data-npp-option-value]').forEach((button) => {
        button.addEventListener('click', () => {
          group.querySelectorAll('[data-npp-option-value]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
          button.setAttribute('aria-pressed', 'true');
          selectedOptions[index] = button.dataset.nppOptionValue;
          group.querySelector('[data-npp-selected-option]').textContent = button.dataset.nppOptionValue;
          updateVariant();
        });
      });
    });

    hero.querySelectorAll('[data-gallery-image]').forEach((button) => {
      button.addEventListener('click', () => {
        hero.querySelectorAll('[data-gallery-image]').forEach((item) => item.setAttribute('aria-current', 'false'));
        button.setAttribute('aria-current', 'true');
        mainImage.src = button.dataset.gallery;
        mainImage.alt = button.dataset.alt;
      });
    });

    hero.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
    });
    hero.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      quantity.value = Math.min(9, Number(quantity.value || 1) + 1);
    });

    updateVariant();
  };

  const init = (scope = document) => initHero(scope);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

